import { render, staticRenderFns } from "./StockCart.vue?vue&type=template&id=2e42fecb&scoped=true"
import script from "./StockCart.vue?vue&type=script&lang=js"
export * from "./StockCart.vue?vue&type=script&lang=js"
import style0 from "./StockCart.vue?vue&type=style&index=0&id=2e42fecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42fecb",
  null
  
)

export default component.exports